var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"refPlayer",class:(_vm.name + "__wrap"),attrs:{"data-testid":"video-player-index-t9rMsW"},on:{"click":_vm.emitClick}})}
var staticRenderFns = []

export { render, staticRenderFns }